<p-dialog [visible]="visible()" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
    [style]="{ width: '520px', maxWidth: '95vw' }" (onHide)="onHide()">

    <ng-template pTemplate="header">
        <div class="dialog-header">
            <div class="dialog-header-icon">
                <i class="pi pi-user"></i>
            </div>
            <div>
                <h3 class="dialog-title">Mi Perfil</h3>
                <p class="dialog-subtitle">Actualizá tus datos personales y contraseña</p>
            </div>
        </div>
    </ng-template>

    <form [formGroup]="form" class="dialog-form" novalidate>

        <div class="profile-summary">
            <div class="user-avatar">{{ user()?.fullName?.charAt(0) ?? '?' }}</div>
            <div class="summary-info">
                <span class="summary-name">{{ user()?.fullName }}</span>
                <span class="summary-email">{{ user()?.email }}</span>
                <span class="role-chip" [class]="'role-' + (user()?.role ?? '').toLowerCase()">{{ user()?.role }}</span>
            </div>
        </div>

        <!-- Nombre completo -->
        <div class="field">
            <label>Nombre completo <span class="req">*</span></label>
            <input pInputText formControlName="fullName" placeholder="Nombre y apellido"
                [class.ng-invalid]="hasError('fullName','required')" />
            @if (hasError('fullName','required')) {
            <small class="error-msg">El nombre es obligatorio</small>
            }
        </div>

        <!-- Teléfono -->
        <div class="field">
            <label>Teléfono</label>
            <input pInputText formControlName="phone" placeholder="0981 123 456" />
        </div>

        <!-- Email (solo lectura) -->
        <div class="field">
            <label>Email</label>
            <input pInputText [value]="user()?.email" disabled />
            <small class="optional-hint">El email no se puede modificar</small>
        </div>

        <hr class="divider" />

        <div class="section-title">Cambiar contraseña</div>

        <div class="form-grid-2">
            <!-- Contraseña actual -->
            <div class="field">
                <label>Contraseña actual</label>
                <p-password formControlName="currentPassword" [feedback]="false" [toggleMask]="true" styleClass="w-full"
                    inputStyleClass="w-full" placeholder="••••••••" />
            </div>

            <!-- Nueva contraseña -->
            <div class="field">
                <label>Nueva contraseña</label>
                <p-password formControlName="newPassword" [toggleMask]="true" styleClass="w-full"
                    inputStyleClass="w-full" placeholder="••••••••" appendTo="body" />
                @if (hasError('newPassword','minlength')) {
                <small class="error-msg">Mínimo 6 caracteres</small>
                }
            </div>
        </div>

    </form>

    <ng-template pTemplate="footer">
        <div class="dialog-footer">
            <button class="btn-danger" (click)="onHide()"><i class="pi pi-times"></i> Cancelar</button>
            <button class="btn-primary" [class.loading]="saving()" [disabled]="saving()" (click)="save()">@if (saving()) { <i class="pi pi-spin pi-spinner"></i> } @else { <i class="pi pi-save"></i> }{{ saving() ? 'Guardando…' : 'Guardar cambios' }}</button>
        </div>
    </ng-template>

</p-dialog>

<p-toast position="top-right" key="toast" />